var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHomeDeveloperArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 19,
    viewBox: "0 0 21 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.11709 18.3525L0.841021 0.0938273L20.732 2.07076L14.3612 6.15498C12.6293 7.26532 11.3916 9.00022 10.9054 10.9993L9.11709 18.3525Z",
    fill: "#01ACFE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeDeveloperArrow);
export default __webpack_public_path__ + "static/media/home_developerArrow.007ccba6bef2f8654fd103c049878496.svg";
export { ForwardRef as ReactComponent };